var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "footer",
    { staticClass: "footer", attrs: { "data-nosnippet": "" } },
    [
      _c(
        "section",
        { staticClass: "footer-group footer-group-brand py-5 pb-2" },
        [
          _c(
            "div",
            { staticClass: "footer-group-row gx-2 gy-4" },
            [
              _vm.footerColumns.column1
                ? _c(
                    "div",
                    {
                      staticClass:
                        "footer-col footer-brand col-logo ms-2 col-12 col-sm-6 col-md-4 col-lg-2 mb-4 mb-lg-0 text-lg-start p-0"
                    },
                    [
                      _vm.footerColumns.column1.logo
                        ? _c("img", {
                            staticClass: "footer-logo",
                            attrs: {
                              src: _vm.footerColumns.column1.logo.url,
                              alt: _vm.footerColumns.column1.logo.alt || "Logo"
                            }
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.footerColumns.column1.button_url &&
                      _vm.footerColumns.column1.button_text
                        ? _c(
                            "a",
                            {
                              staticClass: "btn btn-primary",
                              attrs: {
                                href: _vm.footerColumns.column1.button_url
                              }
                            },
                            [
                              _vm._v(
                                "\n            " +
                                  _vm._s(
                                    _vm.footerColumns.column1.button_text
                                  ) +
                                  "\n          "
                              )
                            ]
                          )
                        : _vm._e()
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm._l([2, 3, 4], function(i) {
                return _vm.footerColumns["column" + i]
                  ? [
                      _c(
                        "div",
                        {
                          class: [
                            "col-12",
                            "col-sm-6",
                            "col-md-4",
                            i === 3 ? "col-lg-3" : "col-lg-2",
                            "mb-1",
                            "mb-lg-0",
                            "footer-col",
                            "ml-lg-4",
                            "ml-md-0",
                            "mt-4",
                            "mt-lg-0"
                          ]
                        },
                        [
                          _c("h5", { staticClass: "mb-3" }, [
                            _vm._v(
                              _vm._s(_vm.footerColumns["column" + i].heading)
                            )
                          ]),
                          _vm._v(" "),
                          _c(
                            "ul",
                            _vm._l(
                              _vm.footerColumns["column" + i].links,
                              function(link) {
                                return _c(
                                  "li",
                                  {
                                    key: link.link.url,
                                    staticClass: "mb-2 menu-footer-menu"
                                  },
                                  [
                                    _c(
                                      "a",
                                      {
                                        staticClass:
                                          "text-decoration-none menu-item menu-item-type-post_type menu-item-object-page",
                                        attrs: {
                                          href: link.link.url,
                                          target: link.link.target || "_blank",
                                          rel: "noopener"
                                        }
                                      },
                                      [
                                        _vm._v(
                                          "\n                  " +
                                            _vm._s(link.link.title) +
                                            "\n                "
                                        )
                                      ]
                                    )
                                  ]
                                )
                              }
                            ),
                            0
                          )
                        ]
                      ),
                      _vm._v(" "),
                      i < 4
                        ? _c(
                            "div",
                            {
                              key: "hr-" + i,
                              staticClass:
                                "col-12 mb-1 d-lg-none d-md-none d-sm-none mt-4"
                            },
                            [_c("hr", { staticClass: "footer-divider" })]
                          )
                        : _vm._e()
                    ]
                  : _vm._e()
              }),
              _vm._v(" "),
              _vm._m(0),
              _vm._v(" "),
              _vm.footerColumns.column5
                ? _c(
                    "div",
                    {
                      staticClass:
                        "footer-col social-icons col-12 col-sm-6 col-md-4 col-lg-2 mb-4 mb-lg-0 text-left social-media-icons ml-lg-0 ml-md-0 mt-4 mt-lg-0"
                    },
                    [
                      _c("h5", { staticClass: "font-bold mb-3" }, [
                        _vm._v(_vm._s(_vm.footerColumns.column5.heading))
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "d-flex gap-3" },
                        _vm._l(
                          ["linkedin", "youtube", "instagram", "facebook"],
                          function(platform) {
                            return _vm.footerColumns.column5[
                              platform + "_url"
                            ] && _vm.footerColumns.column5[platform + "_icon"]
                              ? _c(
                                  "a",
                                  {
                                    key: platform,
                                    attrs: {
                                      href:
                                        _vm.footerColumns.column5[
                                          platform + "_url"
                                        ],
                                      target: "_blank",
                                      rel: "noopener"
                                    }
                                  },
                                  [
                                    _c("img", {
                                      staticClass: "img-fluid",
                                      attrs: {
                                        src:
                                          _vm.footerColumns.column5[
                                            platform + "_icon"
                                          ].url,
                                        alt: platform
                                      }
                                    })
                                  ]
                                )
                              : _vm._e()
                          }
                        ),
                        0
                      )
                    ]
                  )
                : _vm._e()
            ],
            2
          )
        ]
      ),
      _vm._v(" "),
      _c(
        "section",
        { staticClass: "footer-group footer-group-brand-copyright" },
        [
          _vm.footerColumns.copyright_notice
            ? _c("div", { staticClass: "footer-copyright" }, [
                _c("div", { staticClass: "py-2 footer-col" }, [
                  _c("small", [
                    _vm._v(
                      "© " +
                        _vm._s(new Date().getFullYear()) +
                        " " +
                        _vm._s(_vm.footerColumns.copyright_notice)
                    )
                  ])
                ])
              ])
            : _vm._e()
        ]
      )
    ]
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      { staticClass: "col-12 mb-1 d-lg-none d-md-none d-sm-none mt-0" },
      [_c("hr", { staticClass: "footer-divider" })]
    )
  }
]
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-a0c44b9e", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a0c44b9e","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./public/js/components/AppFooter.vue
// module id = 537
// module chunks = 0